import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import {
  Transaction,
  TransactionDetail,
  TransactionCreate,
  Reconciliation,
} from '@core/types/finance.type';
import { PaginationResult, PaginationConfig } from './unit.service';
import { buildPaginationBody } from '@core/utils/pagination.util';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance/transactions`;

  getTransactions(config: PaginationConfig): Observable<ApiResponse<PaginationResult<Transaction>>> {
    return this.http.post<ApiResponse<PaginationResult<Transaction>>>(
      `${this.apiUrl}/grid`,
      buildPaginationBody(config)
    );
  }

  getTransaction(id: string): Observable<ApiResponse<TransactionDetail>> {
    return this.http.get<ApiResponse<TransactionDetail>>(`${this.apiUrl}/${id}`);
  }

  createManualTransaction(data: TransactionCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  reconcileTransactions(data: Reconciliation): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/reconcile`, data);
  }
}
